import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevo 5 años jugando y siempre sentía que llegaba un paso tarde. Con este sistema empecé a reaccionar más rápido y mis decisiones mejoraron un montón. Lo recomiendo 100%.',
    name: 'Martín Rodríguez',
    age: 28,
    city: 'Buenos Aires'
  }, {
    quote: 'Entrenaba 3 veces por semana pero no veía mejoras. Este método me mostró que estaba practicando mal. Ahora entreno menos tiempo pero mucho más eficiente.',
    name: 'Lucas Fernández',
    age: 24,
    city: 'Rosario'
  }, {
    quote: 'La diferencia es abismal. Antes dudaba en cada jugada, ahora actúo sin pensar. Mis compañeros notaron el cambio enseguida.',
    name: 'Sebastián Gómez',
    age: 31,
    city: 'Córdoba'
  }, {
    quote: 'El sistema integra todo: físico, técnica y táctica juntos. Es exactamente lo que necesitaba para dar el salto de nivel.',
    name: 'Diego Pereyra',
    age: 26,
    city: 'Mendoza'
  }, {
    quote: 'Invertí en varios libros de hockey pero este es el único que me dio resultados reales. Desde el día 1 noté la diferencia en mi juego.',
    name: 'Facundo Torres',
    age: 29,
    city: 'La Plata'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-122">
      <div className="text-center mb-16" data-id="element-123">
        <h2 className="font-heading text-4xl md:text-5xl font-bold mb-6 text-[#faf5e8]" data-id="element-124">
          Lo que dicen los jugadores
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-125">
        {testimonials.map((t, index) => <div key={index} className={`bg-[#223322] p-8 rounded-2xl border border-green-800/40 ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-126">
            <div className="flex gap-1 mb-6" data-id="element-127">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#c8e6c9] text-[#c8e6c9]" data-id="element-128" />)}
            </div>
            <p className="text-[#d4d0c4] text-lg mb-8 italic leading-relaxed" data-id="element-129">
              "{t.quote}"
            </p>
            <div data-id="element-130">
              <p className="font-heading font-bold text-[#faf5e8] text-lg" data-id="element-131">
                {t.name}
              </p>
              <p className="text-[#a8c5a8] text-sm" data-id="element-132">
                {t.age} años • {t.city}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}